import common from "../common";
import QuestionModuleAlgebra from "../maths/modules/QuestionModuleAlgebra";
import QuestionModel from "../maths/QuestionModel";
import QuestionValue from "../maths/QuestionValue";
import GelScene from "../ui/gel/GelScene";
import QuestionInputKeypad from "../ui/input/QuestionInputKeypad";
import QuestionInputSelect from "../ui/input/QuestionInputSelect";
import QuestionInputSort from "../ui/input/QuestionInputSort";
import QuestionView from "../ui/view/QuestionView";
import QuestionViewStatement from "../ui/view/QuestionViewStatement";
import QuestionViewStatementAlgebra from "../ui/view/QuestionViewStatementAlgebra";

export default class QuestionScene extends GelScene {
    constructor() {
        super();
    }

    init() {
        super.init();

        const question = new QuestionModel();
        question.values = [
            new QuestionValue(20),
            new QuestionValue(20),
            new QuestionValue(20)
        ];
        question._template = "generic/default";

        this._input = new QuestionInputSelect(question, new QuestionView(question));
        this._input.position.set(common.STAGE_WIDTH * 0.5, P3.View.height * 0.5);
        this._input.init();
        //this.addChild(this._input);

        this._view = new QuestionViewStatement(question);
        this._view.position.set(common.STAGE_WIDTH * 0.5, 600);
        this._view.signals.confirm.add(() => {
            console.log("IS CORRECT : " + this._view.isCorrect());
        }, this);
        this.addChild(this._view);
    }

    resize() {
        super.resize();

        this.hitArea = new PIXI.Rectangle(
            (common.STAGE_WIDTH - P3.View.width) * 0.5,
            0,
            P3.View.width,
            P3.View.height
        );
    }

    update() {
        const dt = window.dt;
        this._input && this._input.update(dt);
    }
}